import { render, staticRenderFns } from "./PagesFooter.vue?vue&type=template&id=49b6f690&scoped=true&"
import script from "./PagesFooter.vue?vue&type=script&lang=js&"
export * from "./PagesFooter.vue?vue&type=script&lang=js&"
import style0 from "./PagesFooter.vue?vue&type=style&index=0&id=49b6f690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6f690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSheet})
